import { render, staticRenderFns } from "./all_odds.vue?vue&type=template&id=57f430a9&scoped=true&"
import script from "./all_odds.vue?vue&type=script&lang=js&"
export * from "./all_odds.vue?vue&type=script&lang=js&"
import style0 from "./all_odds.vue?vue&type=style&index=0&id=57f430a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f430a9",
  null
  
)

export default component.exports